import type {
  LiksMembersPanelLabels,
  LiksMembersPanelMember,
} from '../../../components/liks/LiksMembersPanel/LiksMembersPanel';
import type {
  KnowledgeBaseMembership,
  KnowledgeMemberRole,
} from '../../../types/knowledge';

export const KNOWLEDGE_MEMBER_ROLES: KnowledgeMemberRole[] = [
  'ADMIN',
  'EDITOR',
  'VIEWER',
];

const ROLE_RANK: Record<KnowledgeMemberRole, number> = {
  VIEWER: 1,
  EDITOR: 2,
  ADMIN: 3,
};

export function toKnowledgePanelMember(
  member: KnowledgeBaseMembership,
): LiksMembersPanelMember<KnowledgeMemberRole> | null {
  if (
    typeof member.id !== 'string' ||
    member.id.length === 0 ||
    typeof member.userId !== 'string' ||
    member.userId.length === 0 ||
    !member.role
  ) {
    return null;
  }

  return {
    id: member.id,
    userId: member.userId,
    role: member.role,
  };
}

export function maxKnowledgeMemberRole(
  left: KnowledgeMemberRole,
  right: KnowledgeMemberRole,
): KnowledgeMemberRole {
  return ROLE_RANK[left] >= ROLE_RANK[right] ? left : right;
}

export function buildKnowledgeMembersPanelLabels(
  translate: (key: string, params?: Record<string, string>) => string,
): LiksMembersPanelLabels {
  return {
    loading: translate('knowledge.members.loading'),
    loadError: translate('knowledge.members.loadError'),
    membersHeading: translate('knowledge.members.membersHeading'),
    membersEmpty: translate('knowledge.members.membersEmpty'),
    othersHeading: translate('knowledge.members.othersHeading'),
    othersEmpty: translate('knowledge.members.othersEmpty'),
    inviteNoResults: translate('knowledge.members.inviteNoResults'),
    add: translate('knowledge.members.add'),
    addMember: translate('knowledge.members.addMember'),
    roleLabel: translate('knowledge.members.roleLabel'),
    inviteRoleLabel: translate('knowledge.members.inviteRoleLabel'),
    removeMember: translate('knowledge.members.removeMember'),
    removeLabel: translate('knowledge.members.removeLabel'),
    removeMemberTitle: translate('knowledge.members.removeMemberTitle'),
    removeMemberMessage: translate('knowledge.members.removeMemberMessage'),
    removeConfirm: translate('knowledge.deleteConfirm'),
    removeCancel: translate('knowledge.deleteCancel'),
    leaveLabel: translate('knowledge.members.leaveLabel'),
    leaveMember: translate('knowledge.members.leaveMember'),
    leaveTitle: translate('knowledge.members.leaveTitle'),
    leaveMessage: translate('knowledge.members.leaveMessage'),
    leaveConfirm: translate('knowledge.members.leaveConfirm'),
    leaveCancel: translate('knowledge.deleteCancel'),
    youBadge: translate('knowledge.members.youBadge'),
    searchLabel: translate('knowledge.members.searchLabel'),
    searchPlaceholder: translate('knowledge.members.searchPlaceholder'),
    searchClear: translate('common.search.clear'),
    unknownUser: translate('knowledge.members.unknownUser'),
    copyEmail: translate('knowledge.members.copyEmail'),
    copyEmailCopied: translate('knowledge.members.copyEmailCopied'),
  };
}
